// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {AuthService} from 'src/services/auth-service';
import {NotificationService} from 'src/services/notification-service';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '../environments/environment';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  serverDownNotification: number;

  constructor(
    private authService: AuthService,
    private notification: NotificationService,
    private router: Router,
    private translate: TranslateService
  ) {
    this.serverDownNotification = 0;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(tap(
      event => {
        if (event instanceof HttpResponse) {
          if (event.status === 200 && this.serverDownNotification !== 0) {
            this.serverDownNotification = 0;
          }
        }
      },
      err => {
        this.translate.get(['ERROR_SERVICE_INTERRUPTION', 'ERROR_402']).subscribe(vals => {
          if (err instanceof HttpErrorResponse) {
            switch (err.status) {
              case 0:
              case 503:
              case 504:
                if (err?.error?.type !== 'abort') {
                  const url = this.router.url;
                  if (!url.startsWith('/maintenance')) {
                    if (err.status === 0 && err.url.includes('api/policy/extract-subject')) {
                      environment.__DEV__ && console.log('Failed to extract data from the uploaded certificate.');
                      break;
                    } else {
                      this.authService.maintenanceMode$.next(true);
                      this.router.navigate(['maintenance'], {
                        queryParams: {
                          redirect: url
                        }
                      });
                    }
                  }
                } else {
                  environment.__DEV__ && console.log('Abort error type: Error message suppressed.');
                }
                break;
              case 401:
                this.authService.logout();
                break;
              case 402:
                if (req.url.endsWith('/activationtokens')) {
                  this.router.navigate(['licenses']);
                  this.notification.showError(vals['ERROR_402']);
                }
                break;
              case 403:
                // TODO: Handle here? The generic case where the user might not
                // have the necessary permissions for a resource?
                break;
            }
            if (err.status >= 500 && err.status !== 503 && err.status !== 504) {
              environment.__DEV__ && console.log(err);
              this.notification.showError(vals['ERROR_SERVICE_INTERRUPTION']);
            }
          }
        });
      }));
  }
}
